import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block text-xs" }
const _hoisted_2 = { class: "block text-xs" }

import { TranslateKey, useInject } from '@/composables/use-inject';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemFavoritesHeader',
  setup(__props) {

const translate = useInject(TranslateKey);

const formatItemFavoritesHeaderText = (text: string): string => {
  return `– ${text}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(formatItemFavoritesHeaderText(_unref(translate)('itemFavorites.headerTextRegister'))), 1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(formatItemFavoritesHeaderText(_unref(translate)('itemFavorites.headerTextCount'))), 1)
  ], 64))
}
}

})